export default "__VITE_ASSET__SNdQSUD9__"